import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage   from "./HomePage";
import Dashboard  from "./Dashboard";
import ComingSoon from "./ComingSoon";
import UploadPage from "./UploadPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"            element={<HomePage />}   />
        <Route path="/dashboard"   element={<Dashboard />}  />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/upload"      element={<UploadPage />} />
      </Routes>
    </BrowserRouter>
  );
}